import { render, staticRenderFns } from "./JFile.vue?vue&type=template&id=04c3844a"
import script from "./JFile.vue?vue&type=script&lang=js"
export * from "./JFile.vue?vue&type=script&lang=js"
import style0 from "./JFile.vue?vue&type=style&index=0&id=04c3844a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports